import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import { TableComp } from 'sz-react-utils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { Button, Card, Form, Row, Col, Tooltip, DatePicker, Select, Drawer, Tabs, notification } from 'antd'
import _ from 'lodash'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import AddStaffLeave from '../../components/_utils/addStaffLeave';
import StaffLeaveAction from '../../components/_utils/staffLeaveAction.js';
import moment from 'moment'
import { RightsWrapper } from '../../components/_utils/utils'
import ViewResignationDetail from '../../components/_utils/viewResignationDetail'


const TabPane = Tabs.TabPane

const { MonthPicker } = DatePicker
const Option = Select.Option;

@Form.create()
class ResignationAction extends Component {
    state = {
        visible: true,
        resignApprove: null,
        resignDisapprove: false,
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    handleSubmit = (e) => {
        let { form, dispatch, record } = this.props;
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            let data = {
                _id: record._id,
                userId: record.userId
            }
            if (values.status === "Approve") {
                data.status = "Approved"
                data.lastWorkingDate = values.lastWorkingDate
            } else if (values.status === "Disapprove") {
                data.status = "Disapproved"
                data.disapproveReason = values.disapproveReason
            }
            let response = await Request.updateResignation(data);
            if (!response.error) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }

    componentDidMount() {

    }



    render() {
        const { resignApprove, resignDisapprove, visible } = this.state
        let { record } = this.props
        const {
            form: { getFieldDecorator }
        } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Action',
                    key: 'status',
                    type: 'select',
                    required: true,
                    options: ['Approve', 'Disapprove'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v });
                        if (v === "Approve") {
                            this.setState({ resignApprove: true, resignDisapprove: false })
                        } else if (v === 'Disapprove') {
                            this.setState({ resignDisapprove: true, resignApprove: false })
                        }
                    }
                },
                {
                    label: 'Last Working Date',
                    key: 'lastWorkingDate',
                    type: 'date',
                    hidden: !resignApprove,
                    required: resignApprove,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: "Disapprove Reason",
                    key: 'disapproveReason',
                    type: 'text',
                    hidden: !resignDisapprove,
                    required: resignDisapprove
                }
            ]
        }
        return (
            <Drawer
                title="Approve/Disapprove Resignation"
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={600}
            >
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} apiurl={API_URL} getFieldDecorator={getFieldDecorator} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}



@Form.create()
class UpdateTeamAppraisalRequest extends Component {
    state = {
        visible: true,
        appraisalRequestApproved: false
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let { form, record } = this.props
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            values._id = record._id
            if (values.action === "Approved") {
                values.activeStatus = "Approved By HR";
                values.approvedByHod = true;
                delete values.action
            } else if (values.action === "Disapproved") {
                values.activeStatus = "Disapproved By HR";
                values.approvedByHod = false;
                values.status = values.action;
                delete values.action
            }
            let response = await Request.updateAppraisalRequest(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }

    setFieldsValue() {
        let { record } = this.props
        setTimeout(() => {
            this.props.form.setFieldsValue({ expectedAppraisal: record.expectedAppraisal, appraisalByHod: record.appraisalByHod })
        }, 50)
    }

    componentDidMount() {

    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }

    render() {
        let { appraisalRequestApproved, visible } = this.state
        let inputTypes = {
            fields: [
                {
                    label: 'Action',
                    key: 'action',
                    type: 'select',
                    options: ["Approved", "Disapproved"],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ action: v })
                        if (v === "Approved") {
                            this.setState({ appraisalRequestApproved: true })
                            this.setFieldsValue()
                        } else if (v === "Disapproved") {
                            this.setState({ appraisalRequestApproved: false })
                        }
                    }
                },
                {
                    label: 'Expected Appraisal',
                    key: 'expectedAppraisal',
                    type: 'number',
                    disabled: true,
                    hidden: !appraisalRequestApproved
                },
                {
                    label: 'Appraisal By HOD',
                    key: 'appraisalByHod',
                    type: 'number',
                    disabled: true,
                    hidden: !appraisalRequestApproved
                },
                {
                    label: 'Final Appraisal',
                    key: 'finalAppraisal',
                    type: 'number',
                    required: appraisalRequestApproved,
                    hidden: !appraisalRequestApproved
                }
            ]
        }

        let { form: { getFieldDecorator, getFieldValue }, record } = this.props
        return (
            <Drawer
                title={`Update ${record.userId.name} Appraisal Request`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={500}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={API_URL} inputSchema={inputTypes} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}

@Form.create()
class UpdateAppraisalByManagement extends Component {
    state = {
        visible: true,
        appraisalRequestApproved: false
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let { form, record } = this.props
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            values._id = record._id
            if (values.action === "Approved") {
                values.activeStatus = "Approved By Management";
                values.status = values.action;
                values.approvedByHod = true;
                values.managementComment = values.managementComment;
                delete values.action
            } else if (values.action === "Disapproved") {
                values.activeStatus = "Disapproved By Management";
                values.approvedByHod = false;
                values.status = values.action;
                values.managementComment = values.managementComment;
                delete values.action
            }
            let response = await Request.updateAppraisalRequest(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }

    setFieldsValue() {
        let { record } = this.props
        setTimeout(() => {
            this.props.form.setFieldsValue({ finalAppraisal: record.finalAppraisal, salary: record.userId.salary })
        }, 50)
    }

    componentDidMount() {

    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }

    render() {
        let { appraisalRequestApproved, visible } = this.state
        let inputTypes = {
            fields: [
                {
                    label: 'Action',
                    key: 'action',
                    type: 'select',
                    options: ["Approved", "Disapproved"],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ action: v })
                        if (v === "Approved") {
                            this.setState({ appraisalRequestApproved: true })
                            this.setFieldsValue()
                        } else if (v === "Disapproved") {
                            this.setState({ appraisalRequestApproved: false })
                        }
                    }
                },
                {
                    label: 'Current Salary',
                    key: 'salary',
                    type: 'number',
                    disabled: true,
                    hidden: !appraisalRequestApproved
                },
                {
                    label: 'Final Appraisal',
                    key: 'finalAppraisal',
                    type: 'number',
                    required: appraisalRequestApproved,
                    hidden: !appraisalRequestApproved
                },
                {
                    label: 'Comment',
                    key: 'managementComment',
                    type: 'textarea',
                    hidden: !appraisalRequestApproved
                }
            ]
        }

        let { form: { getFieldDecorator, getFieldValue }, record } = this.props
        return (
            <Drawer
                title={`Update ${record.userId.name} Appraisal Request`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={500}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} inputSchema={inputTypes} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}

@Form.create()
class AddAppraisal extends Component {
    state = {
        visible: true,
        allUsers: []
    }

    componentDidMount() {
        let { users } = this.props;
        this.setState({ allUsers: users })
    }
    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = (e) => {
        let { form } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            let response = await Request.addStaffAppraisal(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }


    render() {
        let { visible, allUsers } = this.state
        let { form: { getFieldDecorator, getFieldValue } } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Select User',
                    key: 'userId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    options: allUsers,
                    onChange: v => {
                        this.props.form.setFieldsValue({ userId: v })
                    }
                },
                {
                    label: 'Appraisal Type',
                    key: 'appraisalType',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    options: ["Performance Appraisal", "Annual Appraisal"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ appraisalType: v })
                    }
                },
                {
                    label: 'Last Apprisal Date',
                    key: 'lastApprisalDate',
                    type: 'date',
                    required: true,
                },
                {
                    label: 'Expected Appraisal',
                    key: 'expectedAppraisal',
                    type: 'number'
                },
                {
                    label: 'Final Appraisal',
                    key: 'finalAppraisal',
                    type: 'number'
                },
                {
                    label: 'Status',
                    key: 'status',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    options: ['Approved', 'Disapproved'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title="Add Team Appraisal"
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={500}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}


@Form.create()
class ApproveRegularisationRequest extends Component {
    state = {
        visible: true,
        regularisationApproved: null,
        regularisationDisapprove: true,
        loading: false
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, data } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                delete data.status
                _.each(data, (val, key) => {
                    values[key] = val
                })
                values.userId = data.userId._id
                values.loginAt = values.startTime
                values.logoutAt = values.endTime
                delete values.startTime
                delete values.endTime
                this.setState({ loading: true })
                let response = await Request.updateRegularisationRequest(values);
                this.setState({ loading: false })
                if (response.success) {
                    this.onClose();
                    notification.success({
                        message: response.message
                    })
                } else {
                    notification.error({
                        message: response.message
                    })
                }
            }
        })
    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    setFieldsValue = () => {
        let { data, form } = this.props
        setTimeout(() => {
            form.setFieldsValue({ startTime: data.loginAt, endTime: data.logoutAt })
        }, 50)
    }


    async componentDidMount() {

    }

    render() {
        const { visible, regularisationApproved, regularisationDisapprove } = this.state

        const inputTypes = {
            fields: [
                {
                    label: 'Action',
                    type: 'select',
                    required: true,
                    key: 'status',
                    options: ["Approved", "Disapproved"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v })
                        if (v === "Approved") {
                            this.setState({ regularisationApproved: true, regularisationDisapprove: true })
                            this.setFieldsValue()
                        } else if (v === "Disapproved") {
                            this.setState({ regularisationApproved: false, regularisationDisapprove: false })
                        }
                    }
                },
                {
                    label: 'Reason',
                    type: 'text',
                    key: 'disapproveReason',
                    required: !regularisationDisapprove,
                    hidden: regularisationDisapprove
                },
                {
                    label: 'Start Time',
                    type: 'time',
                    key: 'startTime',
                    required: regularisationApproved,
                    hidden: !regularisationApproved
                },
                {
                    label: 'End Time',
                    type: 'time',
                    key: 'endTime',
                    required: regularisationApproved,
                    hidden: !regularisationApproved,
                }
            ]
        }

        const {
            form: { getFieldDecorator }
        } = this.props
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Approve/Disapprove Request
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={400}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={API_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}

@Form.create()
class RegularisationRequests extends PureComponent {

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.state = {
            defaultPageSize: 50,
            total: 0,
            showRegularisationForm: false,
            appraisalRecord: {},
            month: moment(),
            leaveMonth: null,
            allUsers: [],
            userId: '',
            activeTab: '0',
            filterYear: '',
            years: ['2023', '2024', '2025', '2026'],
            leaveType: '',
            leaveUserId: '',
            staffLeaveTotal: 0,
            staffAppraisalCount: 0,
            staffResignationsCount: 0,
            leaveStatus: 'Pending',
            showLeaveAddForm: false,
            showLeaveActionForm: false,
            showAppraisalAddForm: false,
            showAprraisalRequestEdit: false,
            showApprovalByManagement: false,
            showResignationActionForm: false,
            resignationDetailDrawerVisible: false,
            appraisalUserId: "",
            resignationRecord: {},
            activeUser: {},
            leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'LWN(Leave Without Notice)', 'HD(Half Day)', 'Sandwich Leave', 'WFH(Work From Home)']
        }
    }

    // region Resignation
    apiResignationRequest = params => {
        return new Promise(async (resolve) => {
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            let response = await Request.getStaffResignations(params);
            this.setState({ staffResignationsCount: response.total })
            resolve(response)
        })
    }

    handleResignationRequest = (record) => {
        this.setState({ showResignationActionForm: true, resignationRecord: record })
    }

    closeResignationForm = () => {
        this.setState({ showResignationActionForm: false, resignationRecord: {} }, () => {
            this.reload()
        })
    }

    showResignationDetailDrawer = (record) => {
        this.setState({ resignationRecord: record, resignationDetailDrawerVisible: true })
    }

    closeResignationDetailDrawer = () => {
        this.setState({ resignationRecord: {}, resignationDetailDrawerVisible: false }, () => {
            this.reload()
        })
    }



    // Staff Resignation Section End

    // region Appraisals


    apiAppraisalRequest = params => {
        return new Promise(async (resolve) => {
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            if (this.state.appraisalUserId) {
                params.userId = this.state.appraisalUserId
            }
            let response = await Request.getStaffAppraisalRequests(params);
            this.setState({ staffAppraisalCount: response.total })
            resolve(response)
        })
    }

    handleAppraisalAdd = () => {
        this.setState({ showAppraisalAddForm: true })
    }


    onAppraisalClose = () => {
        this.setState({ showAppraisalAddForm: false, appraisalRecord: {}, viewDetailRecord: {}, showAppraisalEditForm: false })
        this.reload()
    }

    handleAppraisalRequestEdit = (record) => {
        this.setState({ showAprraisalRequestEdit: true, appraisalRecord: record })
    }

    closeAppraisalEditForm = () => {
        this.setState({ showAprraisalRequestEdit: false, appraisalRecord: {}, showApprovalByManagement: false })
        this.table.current.reload()
    }

    handleActionByManagement = (record) => {
        this.setState({ showApprovalByManagement: true, appraisalRecord: record })
    }


    // Staff Appraisals Section End




    // region Staff Leaves 

    apiStaffLeaveRequest = params => {
        return new Promise(async (resolve) => {
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            if (this.state.filterYear) {
                params.leaveYear = this.state.filterYear
            }
            if (this.state.leaveMonth) {
                params.month = this.state.leaveMonth
            }
            if (this.state.leaveUserId) {
                params.userId = this.state.leaveUserId
            }
            if (this.state.leaveType) {
                params.leaveType = this.state.leaveType
            }
            if (this.state.leaveStatus) {
                params.status = this.state.leaveStatus
            }
            let response = await Request.getStaffLeaveApplications(params)
            this.setState({ staffLeaveTotal: response.total })
            resolve(response)
        })
    }

    handleLeaveMonthChange = (month, dateString) => {
        if (month === null) {
            this.setState({ leaveMonth: null })
            this.reload()
        } else {
            this.setState({ leaveMonth: moment(month) }, () => {
                this.reload()
            })
        }

    }


    handleLeaveAdd = () => {
        this.setState({ showLeaveAddForm: true })
    }

    handleLeaveClose = () => {
        this.setState({ showLeaveAddForm: false })
        this.reload()
    }


    handleStaffLeaveApplication = (record) => {
        this.setState({ showLeaveActionForm: true, record: record })
    }

    handleStaffLeaveApplicationClose = () => {
        this.setState({ showLeaveActionForm: false, record: {} })
        this.table.current.reload()
    }


    // Staff Leaves Section End

    // region Regularisation 

    callBack = (value) => {
        if (value) {
            this.chooseTab(value)
        }
    }

    chooseTab = (value) => {
        this.setState({ activeTab: value })
    }



    //  Regularisation Section End

    reload = () => {
        this.table.current.reload();
    };
    getCurrentUser() {
        let response = JSON.parse(localStorage.getItem('user'));
        this.setState({ activeUser: response })
        return response
    }

    handleMonthChange = (month, dateString) => {
        this.setState({ month: moment(month) }, () => {
            this.reload()
        })
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.month = this.state.month
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            if (this.state.userId) {
                params.userId = this.state.userId
            }
            let response = await Request.getRegularisationRequests(params);
            this.setState({ total: response.total })
            resolve(response)
        })
    }

    handleRegularisationRequests = (record) => {
        this.setState({ showRegularisationForm: true, record: record })
    }

    getCurrentUser = () => {
        let response = JSON.parse(localStorage.getItem('user'))
        return response
    }

    async componentDidMount() {
        let params = {
            sortField: '_id',
            sortOrder: 'ascend',
            results: 200,
            active: true,
            userType: { $ne: "Student" },

        };
        let activeUser = this.getCurrentUser();
        let response = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
        let userArray = [];
        response.data.map((user, index) => {
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({ allUsers: userArray, activeUser: activeUser })
    }

    handleFormClose = () => {
        this.setState({ showRegularisationForm: false, record: {} })
        this.table.current.reload()
    }

    render() {
        const { defaultPageSize, resignationDetailDrawerVisible, resignationRecord, showResignationActionForm, total, years, showApprovalByManagement, showAprraisalRequestEdit, appraisalRecord, showAppraisalAddForm, activeUser, showLeaveActionForm, showLeaveAddForm, leaveTypes, showRegularisationForm, record, allUsers } = this.state

        const staffLeavesColumns = [
            {
                title: 'Employee Name',
                key: 'employeeName',
                fixed: true,
            },
            {
                title: 'Start Date',
                key: 'startDate',
            },
            {
                title: 'Start Time',
                key: 'startTime',
            },
            {
                title: 'End Date',
                key: 'endDate',
            },
            {
                title: 'End Time',
                key: 'endTime',
            },
            {
                title: 'Leave Duration',
                key: 'leaveDuration',
                render: (text, record) => (
                    <div>
                        {record.leaveDuration ? record.leaveDuration > 1 ? <span>{text} Days</span> : <span>{text} Day</span> : null}
                    </div>
                )
            },
            {
                title: 'Last Leave Taken',
                key: 'lastLeaveTaken',
            },
            {
                title: 'Leave Type',
                key: 'leaveType',
            },
            {
                title: 'Asset Details',
                key: 'assetDetails',
            },
            {
                title: 'Leave Reason',
                key: 'leaveReason'
            },
            {
                title: 'Emergency Task Going On',
                key: 'isEmergencyTaskGoingOn',
            },
            {
                title: 'Approved/Disapproved By',
                key: 'updatedByUser.name',
                render: (text, record) => {
                    if (record.status === "Approved" || record.status === "Disapproved") {
                        return (
                            <div>{record.updatedByUser && record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title: 'Status',
                key: 'status',
                filters: [
                    { value: 'Pending', text: 'Pending' },
                    { value: 'Approved', text: 'Approved' },
                    { value: 'Disapproved', text: 'Disapproved' },
                    { value: 'Withdrawn', text: 'Withdrawn' }
                ]
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <React.Fragment>
                        {record.status !== "Withdrawn" ?
                            <Tooltip title="Action">
                                <Button
                                    size={"small"}
                                    shape="circle"
                                    onClick={() => this.handleStaffLeaveApplication(record)}
                                    icon="forward"
                                />
                            </Tooltip>
                            : null}
                    </React.Fragment>
                ),
            }
        ]


        const appraisalColumns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                fixed: 'left',
                width: 70,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Employee Name',
                key: 'userId.name',
                fixed: 'left',
                width: 150
            },
            {
                title: 'Created By',
                key: 'createdByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Requested Appraisal Type',
                key: 'appraisalType'
            },
            {
                title: 'Current Salary',
                key: 'userId.salary',
            },
            {
                title: 'Date of Joining',
                key: 'userId.dateOfJoining',
                render: (text, record) => (
                    <div>{moment(text).format('DD-MMMM-YYYY')}</div>
                )
            },
            {
                title: 'Last Appraisal',
                key: 'previousAppraisal',
                render: text =>
                    moment(text).isValid()
                        ? moment(text).format("DD-MMMM-YYYY")
                        : 'NA'
            },
            {
                title: 'Expected Appraisal',
                key: 'expectedAppraisal'
            },
            {
                title: 'Suggested Appraisal By HOD',
                key: 'appraisalByHod'
            },
            {
                title: 'HOD Name',
                key: 'hodName',
                dataIndex: 'hodId.name'
            },
            {
                title: 'Final Appraisal Amount',
                key: 'finalAppraisal'
            },
            {
                title: 'Approval Status',
                key: 'activeStatus',
            },
            {
                title: 'Performance Report',
                key: 'employeeReport'
            },
            {
                title: 'Appraisal Status',
                key: 'status'
            },
            {
                title: 'Final Comment',
                key: 'managementComment'
            },
            {
                title: 'Last Upadated By',
                key: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <React.Fragment>
                        {record.activeStatus === "Approved By Hod" && activeUser.isHRManager ?
                            <Tooltip title="Edit Appraisal Request">
                                <Button
                                    size={"small"}
                                    shape="circle"
                                    onClick={() => this.handleAppraisalRequestEdit(record)}
                                    icon="edit"
                                />
                            </Tooltip>
                            : null}
                        {
                            record.activeStatus === "Approved By HR" && !activeUser.isHRManager ?
                                <Tooltip title="Edit Appraisal Request">
                                    <Button
                                        size={"small"}
                                        shape="circle"
                                        onClick={() => this.handleActionByManagement(record)}
                                        icon="forward"
                                    />
                                </Tooltip>
                                : null
                        }
                    </React.Fragment>
                ),
            }
        ]

        const resignationColumns = [
            {
                title: 'Employee Name',
                key: 'userId.name',
            },
            {
                title: 'Resignation Reason',
                key: 'resignationReason',
                render: (text, record) => (
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                )
            },
            {
                title: 'Resignation Date',
                key: 'resignationDate',
                render: (val, record) => (
                    <div>
                        {record.resignationDate ? moment(record.resignationDate).format("DD-MM-YYYY") : null}
                    </div>
                )
            },
            {
                title: 'Last Working Date',
                key: 'lastWorkingDate',
                render: (val, record) => (
                    <div>
                        {record.lastWorkingDate ? moment(record.lastWorkingDate).format("DD-MM-YYYY") : null}
                    </div>
                )
            },
            {
                title: 'Created/Updated By',
                key: 'updatedByUser.name',
                render: (text, record) => {
                    if (!record.updatedByUser) {
                        return (
                            <div>{record.createdByUser.name}</div>
                        )
                    } else {
                        return (
                            <div>{record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title: 'Status',
                key: 'status'
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <RightsWrapper myRight={'StaffLeaves.edit'}>
                        <React.Fragment>
                            <Tooltip title="Action">
                                <Button
                                    size={"small"}
                                    shape="circle"
                                    onClick={() => this.handleResignationRequest(record)}
                                    icon="forward"
                                />
                            </Tooltip>&nbsp;
                            <Tooltip title="View Details">
                                <Button
                                    size={'small'}
                                    shape="circle"
                                    icon='eye'
                                    onClick={() => this.showResignationDetailDrawer(record)}
                                ></Button>
                            </Tooltip>
                        </React.Fragment>
                    </RightsWrapper>
                ),
            }
        ]






        const columns = [
            {
                title: 'Employee Name',
                key: 'userId.name',
                fixed: true,
                width: 180
            },
            {
                title: 'Date',
                key: 'attendenceDate',
                render: (text, record) => (
                    <div>
                        {moment(record.attendanceDate, 'YYYY-MM-DD').format('DD-MMMM-YYYY')}
                    </div>
                )
            },
            {
                title: 'Start Time',
                key: 'loginAt'
            },
            {
                title: 'End Time',
                key: 'logoutAt'
            },
            {
                title: 'Reason',
                key: 'updateReason'
            },
            {
                title: 'Status',
                key: 'status'
            },
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={"RegularisationRequests.edit"}>
                            {
                                record.status === "Approved" || record.status === "Disapproved" ?
                                    null :
                                    <Tooltip title="Approve/Disapprove">
                                        <Button
                                            size={"small"}
                                            shape="circle"
                                            onClick={() => this.handleRegularisationRequests(record)}
                                            icon="forward"
                                        />
                                    </Tooltip>
                            }
                        </RightsWrapper>

                    </React.Fragment>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`Staff Requests`}>
                {
                    resignationDetailDrawerVisible ? (
                        <ViewResignationDetail onClose={this.closeResignationDetailDrawer} record={resignationRecord} />
                    ) : null
                }
                {
                    showResignationActionForm ?
                        <ResignationAction record={resignationRecord} onClose={this.closeResignationForm} />
                        : null
                }
                {
                    showApprovalByManagement ?
                        <UpdateAppraisalByManagement record={appraisalRecord} onClose={this.closeAppraisalEditForm} />
                        : null
                }
                {
                    showAprraisalRequestEdit ?
                        <UpdateTeamAppraisalRequest record={appraisalRecord} onClose={this.closeAppraisalEditForm} />
                        : null
                }
                {
                    showAppraisalAddForm ?
                        <AddAppraisal users={allUsers} onClose={this.onAppraisalClose} />
                        : null
                }
                {
                    showLeaveAddForm ?
                        <AddStaffLeave users={allUsers} onClose={this.handleLeaveClose} />
                        : null
                }
                {
                    showRegularisationForm ?
                        <ApproveRegularisationRequest data={record} onClose={this.handleFormClose} />
                        : null
                }
                {
                    showLeaveActionForm ?
                        <StaffLeaveAction record={record} onClose={this.handleStaffLeaveApplicationClose} />
                        : null
                }
                {/* <Card bordered={true}>
                    <Row>
                        <Col span={4}>
                            <label>Search By Month</label><br />
                            <MonthPicker placeholder='Select Month' defaultValue={moment(this.state.month, 'YYYY-DD')} format="YYYY-MM" onChange={this.handleMonthChange} />
                        </Col>
                        <Col span={6}>
                            <label>Search by User</label>
                            <Select
                                allowClear
                                showSearch={true}
                                style={{ width: '90%' }}
                                value={this.state.userId}
                                placeholder="Select Option"
                                optionFilterProp="name"
                                onChange={userId => {
                                    this.setState(
                                        {
                                            userId: userId && userId.toString()
                                        },
                                        () => {
                                            setTimeout(() => {
                                                this.reload()
                                            }, 500);
                                        }
                                    );
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {
                                    allUsers.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>{val.display}</Option>
                                        )
                                    })
                                }

                            </Select>
                        </Col>
                    </Row>
                </Card> */}
                {/* <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1000 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: defaultPageSize,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card> */}
                <Card>
                    <Tabs activeKey={this.state.activeTab} type="card" onChange={this.callBack}>

                        {/*  region Regularisation Requests Tab */}
                        <TabPane key={0} tab={'Regularisation'}>
                            <h2>Total:- {this.state.total}</h2>
                            {/* Filters */}
                            <Row>
                                <Col span={6}>
                                    <label>Search By Month</label><br />
                                    <MonthPicker placeholder='Select Month' defaultValue={moment(this.state.month, 'YYYY-DD')} format="YYYY-MM" onChange={this.handleMonthChange} />
                                </Col>
                                <Col span={6}>
                                    <label>Search by User</label>
                                    <Select
                                        allowClear
                                        showSearch={true}
                                        style={{ width: '90%' }}
                                        value={this.state.userId}
                                        placeholder="Select Option"
                                        optionFilterProp="name"
                                        onChange={userId => {
                                            this.setState(
                                                {
                                                    userId: userId && userId.toString()
                                                },
                                                () => {
                                                    setTimeout(() => {
                                                        this.reload()
                                                    }, 500);
                                                }
                                            );
                                        }}
                                        filterOption={(input, option) => {
                                            return (
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            );
                                        }}
                                    >
                                        {
                                            allUsers.map((val, idn) => {
                                                return (
                                                    <Option key={idn} value={val._id}>{val.display}</Option>
                                                )
                                            })
                                        }

                                    </Select>
                                </Col>
                            </Row>
                            {/* Table */}
                            <Card bordered={true} style={{ marginTop: 10 }}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={this.apiRequest}
                                    extraProps={{ scroll: { x: 1000 } }}
                                    pagination={{
                                        showSizeChanger: false,
                                        defaultPageSize: defaultPageSize,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        {/* Staff Leaves Tab */}
                        <TabPane key={1} tab={"Leaves"}>
                            <h2>Total:{this.state.staffLeaveTotal}</h2>
                            {/* Filter */}
                            <Row gutter={[16, 16]} align="bottom"> {/* Added gutter and bottom alignment */}
                                <Col span={5}>
                                    <label>Search By Month</label>
                                    {/* Removed <br /> and used 100% width for consistent spacing */}
                                    <MonthPicker
                                        placeholder='Select Month'
                                        format="YYYY-MM"
                                        style={{ width: '100%' }}
                                        onChange={this.handleLeaveMonthChange}
                                    />
                                </Col>
                                <Col span={5}>
                                    <label>Search By Year</label>
                                    <Select
                                        allowClear
                                        showSearch={true}
                                        value={this.state.filterYear}
                                        placeholder="Select Year"
                                        style={{ width: '100%', marginLeft: '10px' }} // Standardized width
                                        onChange={filterYear => {
                                            this.setState({ filterYear }, () => {
                                                setTimeout(() => { this.reload() }, 500);
                                            })
                                        }}>
                                        {years && years.map((year, index) => (
                                            <Option key={index} value={year}>{year}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col span={4}>
                                    <label>Search By Leave Type</label>
                                    <Select
                                        allowClear
                                        showSearch={true}
                                        placeholder="Select Leave Type"
                                        style={{ width: '100%' }}
                                        onChange={leaveType => {
                                            this.setState({ leaveType }, () => {
                                                setTimeout(() => { this.reload() }, 500)
                                            })
                                        }}>
                                        {leaveTypes.map((leave, index) => (
                                            <Option key={index} value={leave}>{leave}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col span={3}>
                                    <label>Search by User</label>
                                    <Select
                                        allowClear
                                        showSearch={true}
                                        style={{ width: '100%' }}
                                        value={this.state.leaveUserId}
                                        placeholder="Select Option"
                                        optionFilterProp="name"
                                        onChange={userId => {
                                            this.setState({ leaveUserId: userId && userId.toString() }, () => {
                                                setTimeout(() => { this.reload() }, 500);
                                            });
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {allUsers.map((val, idn) => (
                                            <Option key={idn} value={val._id}>{val.display}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col span={3}>
                                    <label>Search by Status</label>
                                    <Select
                                        allowClear
                                        style={{ width: '100%' }}
                                        value={this.state.leaveStatus}
                                        placeholder="Select Option"
                                        onChange={status => {
                                            this.setState({ leaveStatus: status }, () => {
                                                setTimeout(() => { this.reload() }, 500);
                                            });
                                        }}
                                    >
                                        <Option value='Pending'>Pending</Option>
                                        <Option value='Approved'>Approved</Option>
                                        <Option value='Disapproved'>Disapproved</Option>
                                        <Option value='Withdrawn'>Withdrawn</Option>
                                    </Select>
                                </Col>
                                <RightsWrapper myRight={'StaffLeaves.add'}>
                                    <Col span={2}> {/* Increased span slightly for better spacing */}
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type="primary" onClick={() => this.handleLeaveAdd()}>Add</Button>
                                        </div>
                                    </Col>
                                </RightsWrapper>
                            </Row>
                            {/* Table */}
                            <Card bordered={true} style={{ marginTop: 10 }} >
                                <TableComp
                                    ref={this.table}
                                    columns={staffLeavesColumns}
                                    apiRequest={this.apiStaffLeaveRequest}
                                    extraProps={{ scroll: { x: 1700 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: defaultPageSize,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        {/* Staff Appraisals Tab */}
                        <TabPane key={2} tab={"Appraisals"} type="card" destroyInactiveTabPane>
                            <Row>
                                <h2>Total:{this.state.staffAppraisalCount}</h2>

                                <Col span={6}>
                                    <label>Search by User</label>
                                    <Select
                                        allowClear
                                        showSearch={true}
                                        style={{ width: '90%' }}
                                        value={this.state.appraisalUserId}
                                        placeholder="Select Option"
                                        optionFilterProp="name"
                                        onChange={userId => {
                                            this.setState(
                                                {
                                                    appraisalUserId: userId && userId.toString()
                                                },
                                                () => {
                                                    setTimeout(() => {
                                                        this.reload()
                                                    }, 500);
                                                }
                                            );
                                        }}
                                        filterOption={(input, option) => {
                                            return (
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            );
                                        }}
                                    >
                                        {
                                            allUsers.map((val, idn) => {
                                                return (
                                                    <Option key={idn} value={val._id}>{val.display}</Option>
                                                )
                                            })
                                        }

                                    </Select>
                                </Col>
                                <Col span={2}>
                                    <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                        <Button onClick={() => this.handleAppraisalAdd()}>Add</Button>
                                    </div>
                                </Col>
                            </Row>
                            <Card bordered={true} style={{ marginTop: 10 }} >
                                <TableComp
                                    ref={this.table}
                                    columns={appraisalColumns}
                                    apiRequest={this.apiAppraisalRequest}
                                    extraProps={{ scroll: { x: 1800 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: defaultPageSize,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        {/* Staff Resignations Tab */}
                        <TabPane key={3} tab={"Resignations"}>
                            <Card bordered={true} >
                                <h2>Total:{this.state.staffResignationsCount}</h2>
                                <TableComp
                                    ref={this.table}
                                    columns={resignationColumns}
                                    apiRequest={this.apiResignationRequest}
                                    extraProps={{ scroll: { x: 1450 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: defaultPageSize,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}
const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegularisationRequests)